import { Drawer } from '@mui/material'
import { BasePathProvider } from 'components/Providers'
import { useNavigate, useParams } from 'react-router-dom'
import PersonSearch from './Search'
import PersonDetail from './Person'
import PersonEditForm from './Person/Form/PersonForm'

export default function StaffIndex() {
  const basePath = `/people/staff`
  const navigate = useNavigate()
  const { personId } = useParams()

  return (
    <BasePathProvider value={basePath}>
      <PersonSearch />
      <Drawer
        PaperProps={{
          sx: {
            minWidth: 800,
            width: personId !== 'new' ? 'auto' : 600,
          },
        }}
        open={Boolean(personId)}
        anchor="right"
        onClose={() => navigate(basePath)}
      >
        {personId && personId !== 'new' && <PersonDetail />}
        {personId === 'new' && <PersonEditForm />}
      </Drawer>
    </BasePathProvider>
  )
}
